"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _formatNumber = _interopRequireDefault(require("format-number"));

var _ucfirst = require("@seafront/ucfirst");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _arrayUnique = _interopRequireDefault(require("array-unique"));

var _BlockWithHeader = _interopRequireDefault(require("../01_atoms/BlockWithHeader"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _TicketDetails = _interopRequireDefault(require("../02_molecules/TicketDetails"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _TripPriceDetails = _interopRequireDefault(require("../02_molecules/TripPriceDetails"));

var _TripSeatDetails = _interopRequireDefault(require("../02_molecules/TripSeatDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var TripDetailsWidget = function TripDetailsWidget(_ref) {
  var sdk = _ref.sdk,
      trip = _ref.trip,
      isReturn = _ref.isReturn,
      numberOfPassengers = _ref.numberOfPassengers,
      isOneWayTrip = _ref.isOneWayTrip,
      _ref$showConfirmButto = _ref.showConfirmButton,
      showConfirmButton = _ref$showConfirmButto === void 0 ? true : _ref$showConfirmButto,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      confirmLink = _ref.confirmLink,
      _ref$showSeatsLink = _ref.showSeatsLink,
      showSeatsLink = _ref$showSeatsLink === void 0 ? null : _ref$showSeatsLink;
  var _sdk$i18n = sdk.i18n,
      translationManager = _sdk$i18n.translationManager,
      translatorForNamespace = _sdk$i18n.translatorForNamespace;
  var t = translatorForNamespace('GenericTripDetailsPageUI');
  var selectedSeats = sdk.seats.getSelectedSeats(isReturn);
  var nSelectedSeats = selectedSeats.length;
  var seatsLeftToBook = numberOfPassengers - nSelectedSeats;
  var readableTicketPrice = (numberOfPassengers > 1 ? "".concat(numberOfPassengers, "x ") : '') + formatPrice(trip.grossPrice);

  if (_checkTypes["default"].nonEmptyArray(selectedSeats)) {
    var prices = sdk.seats.getSelectedSeatsData(isReturn).map(function (s) {
      return s.priceInCents / 100;
    });
    var uniquePrices = (0, _arrayUnique["default"])(Array.from(prices)).sort();
    readableTicketPrice = '';
    uniquePrices.forEach(function (price, i) {
      var n = prices.filter(function (p) {
        return p === price;
      }).length;
      readableTicketPrice += "".concat(n, "x ").concat(formatPrice(price));

      if (i < uniquePrices.length - 1) {
        readableTicketPrice += ', ';
      }
    });
  }

  var ticketTitle = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(isReturn ? t('Return trip') : t('Outbound trip'))), /*#__PURE__*/_react["default"].createElement("span", null, readableTicketPrice));

  var ribbonText = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }, sdk.terminals.nameFromId(trip.origin), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "arrow right",
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }), "".concat(sdk.terminals.nameFromId(trip.destination)), "\xA0\xA0\xA0");

  var tripName = t('trip');

  if (!isOneWayTrip) {
    tripName = isReturn ? t('return trip') : t('outbound trip');
  }

  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: isReturn ? t('Return details') : t('Outbound details'),
    rightButtonText: t('Modify'),
    onRightButtonClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_BlockWithHeader["default"], {
    ribbonContent: ribbonText,
    headerContent: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        textAlign: 'left'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '1.6rem',
        fontWeight: '600',
        marginTop: 5,
        marginBottom: 2
      }
    }, sdk.routes.humanPricingForRoute(trip, numberOfPassengers, false)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '0.9rem',
        fontWeight: 'normal'
      }
    }, "".concat(numberOfPassengers, " ").concat(t('passenger')).concat(numberOfPassengers > 1 ? 's' : '')))
  }, /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
    title: ticketTitle,
    ticketDetails: trip,
    nPassengers: numberOfPassengers,
    locale: translationManager.getCurrentLanguage()
  }), /*#__PURE__*/_react["default"].createElement(_TripPriceDetails["default"], {
    trip: trip,
    numberOfPassengers: numberOfPassengers,
    isOneWayTrip: isOneWayTrip,
    translatorForNamespace: translatorForNamespace
  }), /*#__PURE__*/_react["default"].createElement(_TripSeatDetails["default"], {
    id: "seats-details",
    selectedSeats: sdk.seats.getSelectedSeats(isReturn),
    numberOfPassengers: numberOfPassengers,
    translator: t,
    onEditLink: showSeatsLink
  }), showConfirmButton && seatsLeftToBook === 0 && /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: confirmLink,
    fluid: true,
    primary: true
  }, "".concat(t('Confirm'), " ").concat(tripName))))));
};

var _default = TripDetailsWidget;
exports["default"] = _default;